module.exports = __webpack_public_path__ + "img/sr.6a7661fc.png";